<template>
    <c-flip-card
        v-model    = "flipped"
        class      = "w-100 tzb-gadget"
        :top       = "20"
        :right     = "12"
        color      = "primary--text"
        front-icon = "fas fa-edit"
        :enabled   = "data && !!extended"
    >
        <template v-slot:front>
            <div class="w-100 lm-border pa-3" style="height: 200px">
                <v-row class="no-frame">
                    <c-site-tzb-title
                        :title         = "$t('unit.tzb.car.title')"
                        :rating        = "data.rating"
                        :padding-right = "(data.note || extended) ? 24: 0"
                    />
                </v-row>
                <v-row class="no-frame mt-0">
                    <v-col class="no-frame pr-2">
                        <f-read-only-field
                            :label = "$t('unit.tzb.car.wall')"
                            :value = "name (data.wall)"
                            :line  = "false"
                            dense
                        />
                    </v-col>
                    <v-col class="no-frame pr-2">
                        <f-read-only-field
                            :label = "$t('unit.tzb.car.floor')"
                            :value = "name (data.floor)"
                            :line  = "false"
                            dense
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame mt-1">
                    <v-col class="no-frame pr-2">
                        <f-read-only-field
                            :label = "$t('unit.tzb.car.ceiling')"
                            :value = "name (data.ceiling)"
                            :line  = "false"
                            dense
                        />
                    </v-col>
                    <v-col class="no-frame pr-2">
                        <f-read-only-field
                            :label = "$t('unit.tzb.car.lightning')"
                            :value = "name (data.lighting)"
                            :line  = "false"
                            dense
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame mt-1">
                    <v-col class="no-frame pr-2 col-6">
                        <f-read-only-field
                            :label = "$t('unit.tzb.car.mirror')"
                            :value = "name (data.mirror)"
                            :line  = "false"
                            dense
                        />
                    </v-col>
                    <v-col class="no-frame pr-2 col-6">
                        <f-read-only-field
                            :label = "$t('unit.tzb.car.vandalism')"
                            :value = "name (data.vandalism)"
                            :line  = "false"
                            dense
                        />
                    </v-col>
                </v-row>
            </div>
        </template>
        <template v-slot:back>
            <c-site-tzb-note
                :title         = "$t('unit.tzb.car.title')"
                :readonly      = "readonly"
                :tzb-component = "data"
            />
        </template>
    </c-flip-card>
</template>

<script>

import CSiteTzbNote   from "@/modules/msd/unit/components/dialog/CSiteTzbNote";
import CSiteTzbTitle  from "@/modules/msd/unit/components/dialog/CSiteTzbTitle";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField";
import CFlipCard      from "@/modules/core/components/utils/CFlipCard";

export default {
    name: "CSiteTzbCar",
    components: {
        FReadOnlyField,
        CSiteTzbTitle,
        CFlipCard,
        CSiteTzbNote
    },
    props: {
        data: {

        },
        extended: {

        },

        readonly: {

        }
    },

    data: () => ({
        flipped: false
    }),

    methods: {
        name (value) {
            if (!value || !value.name) {
                return "--/--";
            }

            const name = value.name.trim ();
            if (name.length === 0) {
                return "--/--";
            }

            return name;
        }
    }
}
</script>

<style scoped>

</style>